import { ApiClient, GetResponseType } from '@make-software/tg-mini-app-ui';

import { WITH_AUTH } from '@/shared';
import { SeasonInfoResponseType } from '@/entities';

export const getSeasonInfo = async (
  tgInitData?: string
): Promise<GetResponseType<SeasonInfoResponseType>> => {
  const { data, error, loading, httpCode } = await ApiClient.get<SeasonInfoResponseType>(
    `${window.config.api_endpoint}/season-info`,
    tgInitData || WITH_AUTH
  );

  return {
    data,
    httpCode,
    error,
    loading
  };
};
